import 'swiper/css';
import Swiper, {Navigation, Pagination} from 'swiper';
import Observer from '@/common/scripts/observer';

const observer = new Observer();

const initSwiperCards = (typePagination = 'bullets',
    nextButton = '.j-swiper-cards-button-next',
    prevButton = '.j-swiper-cards-button-prev',
    popup = null) => {
    let sliderSelectors = [];

    sliderSelectors = popup ?
        [...popup.content.querySelectorAll('.j-swiper-cards')] :
        [...document.querySelectorAll('.j-swiper-cards:not([data-init])')];

    sliderSelectors.forEach((sliderSelector) => {
        const slider = new Swiper(sliderSelector, {
            modules      : [Navigation, Pagination],
            loop         : true,
            watchOverflow: true,
            pagination   : {
                type             : typePagination,
                el               : '.j-swiper-cards-pagination',
                bulletClass      : 'pagination-slider__bullet',
                bulletActiveClass: 'pagination-slider__bullet_is_active',
                clickable        : true
            },
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton
            }
        });

        sliderSelector.setAttribute('data-init', 'true');

        if (slider.slides.length === 1) {
            slider.navigation.nextEl.style.display = 'none';
            slider.navigation.prevEl.style.display = 'none';
        }
    });
};

initSwiperCards();

// Подписка на открытие попапов
observer.subscribe('popup:open', (popup) => {
    if (!popup.content) {
        return;
    }

    const swiperCards = popup.content.querySelector('.j-swiper-cards');

    if (!swiperCards) {
        return;
    }

    // если нужен числовой пагинатор в галерее
    const typePagination = swiperCards.getAttribute('data-type') ? swiperCards.getAttribute('data-type') : 'bullets';

    initSwiperCards(typePagination, '.j-swiper-cards-button-next', '.j-swiper-cards-button-prev', popup);
});
